import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to (0,0) on every route change.
 * Without this, React Router preserves the previous page's scroll position
 * when navigating — so a page scrolled to the bottom opens the next page
 * at the bottom too.
 *
 * Place this as the first child inside <BrowserRouter> in App.js.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
